/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { a as _arrayWithHoles, b as _nonIterableRest } from './dep-89b33ff6.mjs';
import { a as _iterableToArray } from './dep-f7837681.mjs';
import { a as _unsupportedIterableToArray } from './dep-6bcce672.mjs';

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

export { _toArray as _ };
//# sourceMappingURL=dep-ae77ef8a.mjs.map
